<template>
    <div id="funcionario-editar">
        <section id="content">
            <!--start container-->
            <div class="container">
                <div class="row">
                    <TituloPagina titulo="Editar produto" />
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <!-- <h4 class="header">Editar de produto</h4> -->
                            <div class="row">
                                <form class="col s12" v-on:submit.prevent="save">
                                    <formulario-produto v-if="showForm" @newdata="handleDataProduto($event)" :produto="formData"></formulario-produto>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button class="btn btn-default waves-effect waves-light right" type="submit" name="action">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>
<style>
    .selected {
        color: rgb(0, 188, 212);
        opacity: 1;
    }
    .material-icons.selectable {
        opacity: 0.5;
        cursor: pointer;
    }
</style>
<script>
    import { get, put } from '@/helpers/api';
    import FormularioProduto from './Formulario';
    import Message from '@/helpers/message';
    import TituloPagina from '@/components/common/TituloPagina';
    import { DONO, GERENTE, ESPECIALISTA, MASTER } from '@/constants/funcionarioCargo.js';
    import Auth from '@/store/auth';

    export default {
        components: {
            FormularioProduto,
            TituloPagina
        },
        data: () => ({
            formData: {
                produto_id: '',
                produto_nome: '',
                produto_descricao: '',
                produto_diferenciais: '',
                produto_icone: '',
                produto_obrigatorio: false,
                categoria_id: null,
            },
            showForm: false
        }),
        created() {
            // verifica se pode acessar componente
            if (Auth.getCargoUsuario() !== MASTER && [DONO, GERENTE, ESPECIALISTA].indexOf(Auth.getCargoUsuario()) === -1) {
                this.$router.push('/sempermissao');
            }
            let self = this;
            get('produto/'+this.$route.params.id).then(function (response) {
                let produto = response.data.result.data;
                self.formData.produto_id = produto.produto_id;
                self.formData.produto_nome = produto.produto_nome;
                self.formData.produto_descricao = produto.produto_descricao;
                self.formData.produto_diferenciais = produto.produto_diferenciais;
                self.formData.produto_icone = produto.produto_icone;
                self.formData.produto_obrigatorio = produto.produto_obrigatorio;
                self.formData.categoria_id = produto.categoria_id;
                self.showForm = true;
            });
        },
        methods: {
            save() {
                if (this.formData.produto_nome === '' ||
                    this.formData.produto_descricao === '' ||
                    // this.formData.produto_diferenciais === '' ||
                    this.formData.produto_icone === '') {
                    Message.messageError('Ícone e Descrição são obrigatórios!');
                    return;
                }

                let self = this;
                put('produto/'+this.formData.produto_id, {
                    produto_nome: this.formData.produto_nome,
                    produto_descricao: this.formData.produto_descricao,
                    produto_diferenciais: this.formData.produto_diferenciais,
                    produto_icone: this.formData.produto_icone,
                    produto_obrigatorio: this.formData.produto_obrigatorio,
                    categoria_id: this.formData.categoria_id,
                }).then(function (response) {
                    Message.messageSuccess(response.data.statusMessage);
                    self.$router.push('/produtos', function () {});
                }).catch(function () {
                    Message.messageError('Ocorreu algum erro, tente novamente mais tarde.');
                });
            },
            handleDataProduto(e) {
                [
                    this.formData.produto_nome,
                    this.formData.produto_descricao,
                    this.formData.produto_diferenciais,
                    this.formData.produto_icone,
                    this.formData.produto_obrigatorio,
                    this.formData.categoria_id,
                ] = e;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/produtos/Editar.vue